import { useLocation } from 'react-router-dom';
import { useJobAlert } from '@tinct/web-layout';
import { useQueryClient } from '@tanstack/react-query';

/** Stable tag identifying buyer-import jobs in the global job store. */
export const BUYER_IMPORT_JOB_TAG = 'buyer-import';

type UseBuyerImportJobAlertOptions = {
  jobId: string | null | undefined;
  /** Where the job-alert widget link should send the user once the import
   *  job completes. */
  completedUrl: string;
};

export function useBuyerImportJobAlert({
  jobId,
  completedUrl,
}: UseBuyerImportJobAlertOptions) {
  const { pathname } = useLocation();
  const queryClient = useQueryClient();

  // Distinct `pendingUrl` per job so `JobAlertWidget` (which hides any job
  // whose pendingUrl matches the current pathname) still surfaces it after
  // the user navigates away via "Run in background".
  const pendingUrl = jobId ? `${pathname}#buyer-import=${jobId}` : pathname;

  const { start } = useJobAlert({
    tag: BUYER_IMPORT_JOB_TAG,
    name: 'Customer import',
    pendingUrl,
    completedUrl,
    onStart: () => {
      queryClient.invalidateQueries({ queryKey: ['buyers'] });
    },
    onTerminal: (status) => {
      if (status === 'completed' || status === 'failed') {
        queryClient.invalidateQueries({ queryKey: ['buyers'] });
        return;
      }
    },
  });

  return { start };
}
